import '../../css/sell2uk.css';

const Sell2UK = () => { return null };

export default Sell2UK;